import React from 'react';
import { useLocaleContext } from '../../../../context/LocaleContext';
import getFullname from '../../../../helpers/get-fullname';
import getMemberNickname from '../../../../helpers/get-member-nickname';
import MemberPhoto from '../MemberPhoto';

import './style.scss';

/**
 *
 * @param {object} member Member information
 * @param {DOMElement} children
 * @param {function} onMemberClick callback
 * @returns {ReactComponent}
 */

const MemberInfoCard = ({episodeMember, group, size='', hasPhoto = true, hasName = true, children, onMemberClick}) => {

    const $locale = useLocaleContext();

    return (
        !!episodeMember &&
        <div
            className={`member-info-card ${episodeMember.important ? 'member-info-card--important' : ''} ${!!size ? `member-info-card--${size}` : ''}`}
            onClick={(e) => {
                e.stopPropagation();
                onMemberClick(episodeMember.member);
            }}
        >
            <div className="member-info-card__common member-info-card--row">
                {
                    (hasPhoto && group) &&
                    <div className="member-info-card__common-photo">
                        <MemberPhoto
                            photo={episodeMember.member.previewUrl}
                            initials={getMemberNickname(episodeMember.member, $locale)}
                            size="sm"
                        />
                    </div>
                }
                {
                    hasName &&
                    <div className="member-info-card__common-information">
                        <p className="member-info-card__common-information-name">
                            {getFullname(episodeMember.member, $locale)}
                        </p>
                        <p className="member-info-card__common-information-company">
                            {$locale.getProperty(episodeMember.member, 'company')}
                        </p>
                        <p className="member-info-card__common-information-regalia">
                            {$locale.getProperty(episodeMember.member, 'regalia')}
                        </p>
                        {
                            (group.showTopics && !!$locale.getProperty(episodeMember, 'topic')) &&
                            <p className="member-info-card__theme">
                                <span className="member-info-card__theme-title">
                                    {$locale.get('member.label.theme')}:&nbsp;
                                </span>
                                <span className="member-info-card__theme-description">
                                    {$locale.getProperty(episodeMember, 'topic')}
                                </span>
                            </p>
                        }
                    </div>
                }
            </div>
            {children}
        </div>
    )
};

export default MemberInfoCard;
